import React from 'react';
import { ExposicaoCard } from '../ExposicaoCard/ExposicaoCard';
import { VisitaGuiada } from '../../../domain/entities/VisitaGuiada';
import { VisitaGuiadaCard } from '../VisitaGuiadaCard/VisitaGuiadaCard';
import './Sections.css';

interface ExposicaoSectionProps {
  visitas?: VisitaGuiada[];
}

export const ExposicaoSection: React.FC<ExposicaoSectionProps> = ({ visitas = [] }) => {
  return (
    <section className="content-section">
      <h2 className="section-title">Exposição</h2>
      <ExposicaoCard 
        title="Pandeiros do Brasil: História, Tradição, Inovação"
        description="A exposição permanente é aberta ao público durante todo o horário de funcionamento da casa."
        visitasGuiadas="Visitas guiadas podem ser agendadas para grupos pelo email contato@casadopandeiro.com"
      >
        {visitas.length > 0 && (
          <div className="visitas-guiadas-list compact" style={{marginTop: '1.5rem'}}>
            <h3 className="section-title" style={{marginTop: 0, fontSize: '1.1rem'}}>Próximas Visitas Guiadas</h3>
            <div className="visitas-guiadas-cards-wrapper">
              {visitas.map((visita) => (
                <VisitaGuiadaCard key={visita.id.value} visita={visita} compact />
              ))}
            </div>
          </div>
        )}
      </ExposicaoCard>
    </section>
  );
}; 